import { createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "../../../redux/slice";
import * as api from "../api";
import * as authApi from "../../auth/api";

export const doGetSetting = createAsyncThunk("setting/doGetSetting", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doGetSetting();
    const { response: tokenRes } = await authApi.getToken();
    return error ? thunkAPI.rejectWithValue(error) : { ...response, ...tokenRes };
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateSetting = createAsyncThunk("setting/doUpdateSetting", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdateSetting(params);
    if (!error) thunkAPI.dispatch(setMessage("You action has been completed successfully"));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateSettingNoFetching = createAsyncThunk(
  "setting/doUpdateSettingNoFetching",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doUpdateSetting(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doUpdateBrandSetting = createAsyncThunk("setting/doUpdateBrandSetting", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdateBrandSetting(params);
    if (!error) thunkAPI.dispatch(setMessage("You action has been completed successfully"));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doLanguageTranslate = createAsyncThunk("setting/doLanguageTranslate", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doLanguageTranslate(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doLanguageTranslateNoFetching = createAsyncThunk(
  "setting/doLanguageTranslateNoFetching",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doLanguageTranslate(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);
